import React, {useEffect, useRef, useState} from "react";
import {IButtonRef, ButtonForFramesTopBar} from "../../../../../com/button/Button";

import {ReactComponent as NewSpotsIcon} from "../../../../../assets/editors/spots/new_frames_icon.svg";
import {
    ReactComponent as AutoNumberingHorizontalIcon
} from "../../../../../assets/editors/spots/auto_numbering_horizontal_frames_icon.svg";
import {
    ReactComponent as AutoNumberingVerticalIcon
} from "../../../../../assets/editors/spots/auto_numbering_vertical_frames_icon.svg";
import {ReactComponent as RenumberFromIcon} from "../../../../../assets/editors/spots/renumber_frames_icon.svg";
import {ReactComponent as ChevronUpIcon} from "../../../../../assets/editors/spots/arrow_up_icon.svg";
import {ReactComponent as ChevronDownIcon} from "../../../../../assets/editors/spots/arrow_down_icon.svg";
import "./SpotsTopBarControls.scss";
import {
    EVENT_TYPE_ADD_SPOTS_GRID_COMPLETED,
    EVENT_TYPE_FLYER_PAGE_CONTROLS_AUTO_NUMBER,
    EVENT_TYPE_FLYER_PAGE_CONTROLS_RENUMBER_FROM,
    addEventTypeListener,
    removeEventTypeListener, dispatchEventDataType,
} from "../../../../../globals/EventDispatcher";
import {Box, Button, ClickAwayListener, Typography} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {useTypedSelector} from "../../../../../hooks/useTypeSelector";
import {useDispatch} from "react-redux";
import {changeOrientationNumberingForFrames} from "../../../../../store/actionCreators/spotsActionCreators";

const useStyles = makeStyles(() => ({
    orientationForFramesMenu: {
        position: `absolute`,
        // width: `200px`,
        top: `32px`,
        right: `0`,
        backgroundColor: `white`,
        zIndex: 1,
        border: `1px solid black`,
        display: `flex`,
        flexDirection: `column`,
        width: `192px`,
        '& .MuiTypography-root': {
            fontSize: `12px`,
            color: `#4D4D4D`,
            textAlign: `start`
        }
    },
    orientationForFrameOptionWrapper: {
        '&.MuiButton-root': {
            display: `flex`,
            alignItems: `center`,
            flexFlow: `row`,
            padding: `8px`,
            width: `100%`,
            columnGap: `8px`,
            cursor: `pointer`,
            borderRadius: `0`,
            '&:hover': {
                backgroundColor: `#e4e4e4`,
            },
            '&.activeOption': {
                backgroundColor: `#88888880`,
            }
        }
    }
}))

interface ISpotsTopBarControls {
    showNewSpotControls: (value: boolean) => void;
}

export const SpotsTopBarControls: React.FC<ISpotsTopBarControls> = (props) => {
    const dispatch = useDispatch();
    const newSpotsButtonRef = useRef<IButtonRef | null>(null);
    const [isOpen, setOpen] = useState(false);
    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };
    const {spots} = useTypedSelector((state) => state);
    const classes = useStyles();
    useEffect(() => {
        // executed once
        addEventTypeListener(EVENT_TYPE_ADD_SPOTS_GRID_COMPLETED, () => {
            newSpotsButtonRef.current?.showOn(false);
        });

        return () => {
            removeEventTypeListener(EVENT_TYPE_ADD_SPOTS_GRID_COMPLETED);
        };
    }, []);

    return (
        <div className="spots_top_bar_controls">
            <ButtonForFramesTopBar
                ref={newSpotsButtonRef}
                svg={NewSpotsIcon}
                colorOff="#0B1423"
                colorOn="#E5870E"
                text="+ New Frames"
                onClick={props.showNewSpotControls}
                isToggle={true}
            />
            <Box
                sx={{display: "flex"}}
            >
                {
                    spots.isHorizontalOrientationForFrames
                        ?
                        <ButtonForFramesTopBar
                            svg={AutoNumberingHorizontalIcon}
                            colorOff="#0B1423"
                            colorOn="#E5870E"
                            text="Auto-Number"
                            onClick={() => {
                                dispatchEventDataType(EVENT_TYPE_FLYER_PAGE_CONTROLS_AUTO_NUMBER, spots.isHorizontalOrientationForFrames);
                            }}
                        />
                        :
                        <ButtonForFramesTopBar
                            svg={AutoNumberingVerticalIcon}
                            colorOff="#0B1423"
                            colorOn="#E5870E"
                            text="Auto-Number"
                            onClick={() => {
                                dispatchEventDataType(EVENT_TYPE_FLYER_PAGE_CONTROLS_AUTO_NUMBER, spots.isHorizontalOrientationForFrames);
                            }}
                        />
                }
                <Box sx={{
                    position: `relative`,
                }}>
                    <Button
                        onClick={handleToggle}
                    >
                        {isOpen ? <ChevronUpIcon/> : <ChevronDownIcon/>}
                    </Button>
                    {
                        isOpen &&
                        <ClickAwayListener onClickAway={handleToggle}>
                            <Box
                                className={classes.orientationForFramesMenu}
                            >
                                <Button
                                    className={`${spots.isHorizontalOrientationForFrames ? 'activeOption' : ''} ${classes.orientationForFrameOptionWrapper}`}
                                    disabled={spots.isHorizontalOrientationForFrames}
                                    onClick={() => {
                                        dispatch(changeOrientationNumberingForFrames(true));
                                        // setHorizontalOrientationForAutoNumbering(true);
                                        handleToggle();
                                    }}
                                >
                                    <AutoNumberingHorizontalIcon/>
                                    <Box sx={{
                                        flex: `1 1 auto`
                                    }}>
                                        <Typography>
                                            Horizontal numbering
                                        </Typography>
                                    </Box>
                                </Button>
                                <Button
                                    className={`${!spots.isHorizontalOrientationForFrames ? 'activeOption' : ''} ${classes.orientationForFrameOptionWrapper}`}
                                    disabled={!spots.isHorizontalOrientationForFrames}
                                    onClick={() => {
                                        dispatch(changeOrientationNumberingForFrames(false));
                                        handleToggle();
                                    }}
                                >
                                    <AutoNumberingVerticalIcon/>
                                    <Box sx={{
                                        flex: `1 1 auto`
                                    }}>
                                        <Typography>
                                            Vertical numbering
                                        </Typography>
                                    </Box>
                                </Button>
                            </Box>
                        </ClickAwayListener>
                    }
                </Box>
            </Box>
            <ButtonForFramesTopBar
                svg={RenumberFromIcon}
                colorOff="#0B1423"
                colorOn="#E5870E"
                text="Renumber From"
                onClick={() => {
                    dispatchEventDataType(EVENT_TYPE_FLYER_PAGE_CONTROLS_RENUMBER_FROM, spots.isHorizontalOrientationForFrames);
                }}
            />
        </div>
    );
};
